import React, { useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import { Button } from "primereact/button";
import EzControlledDropDowntWithFloatingLabel from "../../../../common/EzForm/EzControlledDropDown/WithFloatingLabel";
import "./styles.css";
import { goBack } from "../../../../utils/gotoback";
import { loadingShow } from "../../../../services/PostAPI";
import Breadcrumb from "../../../../common/Breadcrumb";
import { useStyles } from "../style";
import {
  basicDetail,
  passengerDD,
  confirmationRequiredDD,
  doorsDD,
  inquiryDD,
  luggageDD,
  statusDD,
  editMode,
} from "../CreateVehicleCategory/constant";
import { Box, Container, Grid } from "@mui/material";
import EzControlledInputWithFloatingLabel from "../../../../common/EzForm/EzControlledInput/WithFloatingLabel";
import { EzToast, TOAST_SEVERITY } from "../../../../common/EzToast";
import { useNavigate } from "react-router-dom";
import { APP_URLS } from "../../../../utils/constant";
import FileUpload from "../../../../common/EzForm/EzFile";
import { vehicleBreadcrumbD } from "../../VehicleTrim/CreateVehicleTrim/constant";

const CreateVehicleCategoryComponent = (props) => {
  const navigate = useNavigate();
  const {
    history,
    initCreateVehicleCategoryScreen,
    createVehicleCategory,
    editVehicleCategory,
    isLoading,
    isVehicleCategoryCreateSuccess,
    isVehicleCategoryCreateError,
    isVehicleCategoryDetailSuccess,
    isVehicleCategoryDetailError,
    isVehicleCategoryEditSuccess,
    isEdit,
    isCopy,
    isView,
    formFieldValueMap,
    shouldBlockNavigation,
    uploadImage,
    imageUploadResponse,
    isUploadImageSuccess,
    isUploadImageError,
    acTypeDD,
    stereoTypeDD,
    transmissionTypeDD,
  } = props;
  console.log("check props of compoemnt", props);

  const classes = useStyles();

  const {
    control,
    formState: { errors, isDirty },
    watch,
    register,
    handleSubmit,
    reset,
  } = useForm({
    defaultValues: useMemo(() => {
      console.log("check value come or not", formFieldValueMap);
      return formFieldValueMap;
    }, [formFieldValueMap]),
  });

  useEffect(() => {
    if (!isVehicleCategoryCreateSuccess && !isVehicleCategoryEditSuccess) {
      shouldBlockNavigation(isDirty);
    }
  }, [isDirty, shouldBlockNavigation, isVehicleCategoryCreateSuccess, isVehicleCategoryEditSuccess]);

  const navigateToVehicleCategoryScreen = () => {
    navigate(APP_URLS.VEHICLE_CATEGORY.HOME);
  };
  useEffect(() => {
    if (isVehicleCategoryCreateSuccess || isVehicleCategoryEditSuccess) {
      reset();
    }
  }, [isVehicleCategoryCreateSuccess, isVehicleCategoryEditSuccess]);
  useEffect(() => {
    if (isVehicleCategoryDetailSuccess) {
      reset({
        ...formFieldValueMap,
      });
    }
  }, [isVehicleCategoryDetailSuccess]);
  useEffect(() => {
    initCreateVehicleCategoryScreen();
  }, []);
  let userId = localStorage.getItem("userId");

  const handleChange = (event) => {
    const files = event.target.files;
    const payload = {
      file: files,
      id: userId,
    };
    if (files) {
      uploadImage(payload);
    }
  };

  const onSubmit = (data) => {
    if (Number(data.depositAmount) < 0) {
      return;
    }
    let newData = data;
    newData["userId"] = localStorage.getItem("userId");
    newData["imgUrl"] = imageUploadResponse || data.imgUrl || formFieldValueMap?.imgUrl;

    const stringifiedData = {
      ...newData,
      id: (isEdit && !isCopy) ? data.id : undefined,
    };

    (isEdit && !isCopy)
      ? editVehicleCategory({ id: data.id, data: stringifiedData })
      : createVehicleCategory(stringifiedData);
  };
  const getToastProps = () => {
    const toastTitle = "Please select category from list";
    return {
      severity: TOAST_SEVERITY.ERROR,
      toastTitle,
      shouldShowToast: false,
    };
  };

  const getFormErrorMessage = (name) => {
    return (
      errors[name] && <small className="p-error">{errors[name].message}</small>
    );
  };

  const renderPageHeaderSection = () => {
    return (
      <div className="make-relative sub-header ">
        <div className="maintitlediv">
          <div className="ml-3">
            <h4 className="pagetitle">{isEdit && !isCopy ? "Update Vehicle Category" : isCopy ? "Copy Vehicle Category" : "Create Vehicle Category"}</h4>
          </div>
          <div className="buttonarea">
            <Button
              tooltip={"Back to Vehicle Category"}
              tooltipOptions={{ position: "left" }}
              label={"Back to Vehicle Category"}
              // icon={"pi pi-arrow-left"}
              className={`p-button `}
              style={{ borderRadius: "10px" }}
              onClick={navigateToVehicleCategoryScreen}
            />
          </div>
        </div>
      </div>
    );
  };

  return (
    <Container maxWidth="lg">
      <Breadcrumb list={vehicleBreadcrumbD} />
      <EzToast {...getToastProps()} />
      <div className={`containerbox ${classes.bg}`}>
        {renderPageHeaderSection()}
        <div className="form-demo">
          <form onSubmit={handleSubmit(onSubmit)} className="p-fluid">
            <Grid container spacing={2}>
              {basicDetail?.map((item) =>
                item.name === "passenger" ? (
                  <Grid item xs={12} sm={6} md={4} lg={3} key={item.name}>
                    <EzControlledDropDowntWithFloatingLabel
                      name={item?.name}
                      control={control}
                      rules={item?.rule}
                      optionLabel={"name"}
                      optionValue={"id"}
                      options={passengerDD}
                      isError={errors[item?.name]}
                      errorMsg={getFormErrorMessage(item?.name)}
                      label={item?.label}
                      labelClassName={"ml-2"}
                    />
                  </Grid>
                ) : item.name === "luggage" ? (
                  <Grid item xs={12} sm={6} md={4} lg={3} key={item.name}>
                    <EzControlledDropDowntWithFloatingLabel
                      name={item?.name}
                      control={control}
                      rules={item?.rule}
                      optionLabel={"name"}
                      optionValue={"id"}
                      options={luggageDD}
                      isError={errors[item?.name]}
                      errorMsg={getFormErrorMessage(item?.name)}
                      label={item?.label}
                      labelClassName={"ml-2"}
                    />
                  </Grid>
                ) :
                item.name === "depositAmount" ? (
                  <Grid item xs={12} sm={6} md={4} lg={3} key={item.name}>
                    <EzControlledInputWithFloatingLabel
                      name={item.name}
                      control={control}
                      label={item.label}
                      type="number"
                      rules={{
                        required: "Deposit Amount is required",
                        min: {
                          value: 0,
                          message: "Deposit Amount cannot be negative",
                        },
                      }}
                      inputProps={{
                        min: 0,
                      }}
                      isError={errors[item.name]}
                      errorMsg={getFormErrorMessage(item.name)}
                    />
                  </Grid>
                ) : item.name === "extraMileageRate" ? (
                  <Grid item xs={12} sm={6} md={4} lg={3} key={item.name}>
                    <EzControlledInputWithFloatingLabel
                      name={item?.name}
                      control={control}
                      label={item?.label}
                      type={item?.type}
                      step="any"
                      rules={item?.rule}
                      isError={errors[item?.name]}
                      errorMsg={getFormErrorMessage(item?.name)}
                    />
                  </Grid>
                ) : item.name === "doors" ? (
                  <Grid item xs={12} sm={6} md={4} lg={3} key={item.name}>
                    <EzControlledDropDowntWithFloatingLabel
                      name={item?.name}
                      control={control}
                      rules={item?.rule}
                      optionLabel={"name"}
                      optionValue={"id"}
                      options={doorsDD}
                      isError={errors[item?.name]}
                      errorMsg={getFormErrorMessage(item?.name)}
                      label={item?.label}
                      labelClassName={"ml-2"}
                    />
                  </Grid>
                ) : item.name === "transmission" ? (
                  <Grid item xs={12} sm={6} md={4} lg={3} key={item.name}>
                    <EzControlledDropDowntWithFloatingLabel
                      name={item?.name}
                      control={control}
                      rules={item?.rule}
                      optionLabel={"name"}
                      optionValue={"id"}
                      options={transmissionTypeDD || []}
                      isError={errors[item?.name]}
                      errorMsg={getFormErrorMessage(item?.name)}
                      label={item?.label}
                      labelClassName={"ml-2"}
                    />
                  </Grid>
                ) : item.name === "stereo" ? (
                  <Grid item xs={12} sm={6} md={4} lg={3} key={item.name}>
                    <EzControlledDropDowntWithFloatingLabel
                      name={item?.name}
                      control={control}
                      rules={item?.rule}
                      optionLabel={"name"}
                      optionValue={"id"}
                      options={stereoTypeDD || []}
                      isError={errors[item?.name]}
                      errorMsg={getFormErrorMessage(item?.name)}
                      label={item?.label}
                      labelClassName={"ml-2"}
                    />
                  </Grid>
                ) : item.name === "ac" ? (
                  <Grid item xs={12} sm={6} md={4} lg={3} key={item.name}>
                    <EzControlledDropDowntWithFloatingLabel
                      name={item?.name}
                      control={control}
                      rules={item?.rule}
                      optionLabel={"name"}
                      optionValue={"id"}
                      options={acTypeDD || []}
                      isError={errors[item?.name]}
                      errorMsg={getFormErrorMessage(item?.name)}
                      label={item?.label}
                      labelClassName={"ml-2"}
                    />
                  </Grid>
                ) : item.name === "confirmationRequired" ? (
                  <Grid item xs={12} sm={6} md={4} lg={3} key={item.name}>
                    <EzControlledDropDowntWithFloatingLabel
                      name={item?.name}
                      control={control}
                      rules={item?.rule}
                      optionLabel={"name"}
                      optionValue={"id"}
                      options={confirmationRequiredDD}
                      isError={errors[item?.name]}
                      errorMsg={getFormErrorMessage(item?.name)}
                      label={item?.label}
                      labelClassName={"ml-2"}
                    />
                  </Grid>
                ) : item.name === "inquiry" ? (
                  <Grid item xs={12} sm={6} md={4} lg={3} key={item.name}>
                    <EzControlledDropDowntWithFloatingLabel
                      name={item?.name}
                      control={control}
                      rules={item?.rule}
                      optionLabel={"name"}
                      optionValue={"id"}
                      options={inquiryDD}
                      isError={errors[item?.name]}
                      errorMsg={getFormErrorMessage(item?.name)}
                      label={item?.label}
                      labelClassName={"ml-2"}
                    />
                  </Grid>
                ) : item.name === "status" ? (
                  <Grid item xs={12} sm={6} md={4} lg={3} key={item.name}>
                    <EzControlledDropDowntWithFloatingLabel
                      name={item?.name}
                      control={control}
                      rules={item?.rule}
                      optionLabel={"name"}
                      optionValue={"id"}
                      options={statusDD}
                      isError={errors[item?.name]}
                      errorMsg={getFormErrorMessage(item?.name)}
                      label={item?.label}
                      labelClassName={"ml-2"}
                    />
                  </Grid>
                ) : (
                  <Grid item xs={12} sm={6} md={4} lg={3} key={item.name}>
                    <EzControlledInputWithFloatingLabel
                      name={item?.name}
                      control={control}
                      label={item?.label}
                      type={item?.type}
                      rules={item?.rule}
                      isError={errors[item?.name]}
                      errorMsg={getFormErrorMessage(item?.name)}
                    />
                  </Grid>
                )
              )}
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <FileUpload
                  register={register}
                  onChange={handleChange}
                  error={errors.file}
                  rules={false}
                />
              </Grid>
            </Grid>

            <div className={"make-flex mt-3 mr-2"}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "end",
                }}
              >
                <React.Fragment>
                  <div
                    style={{ margin: "15px 0px 15px 10px", minWidth: "100px" }}
                  >
                    <Button
                      type="submit"
                      label={isEdit ? "Update" : "Save"}
                      className="mt-2 p-button-raised"
                    />
                  </div>
                </React.Fragment>
              </div>
            </div>

            {isEdit && (
              <Grid className="modsection" container spacing={2}>
                {editMode?.map((item) => (
                  <Grid item xs={12} sm={6} md={4} lg={3} key={item.name}>
                    <EzControlledInputWithFloatingLabel
                      name={item?.name}
                      control={control}
                      disabled={item?.disabled}
                      label={item?.label}
                      type={item?.type}
                      rules={item?.rule}
                      isError={errors[item?.name]}
                      errorMsg={getFormErrorMessage(item?.name)}
                    />
                  </Grid>
                ))}
              </Grid>
            )}
          </form>
        </div>
      </div>
    </Container>
  );
};

export default CreateVehicleCategoryComponent;
